import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Amenity from '../../../components/stateful/Amenity';
import FacilityAmenitiesCarousel from '../../../components/stateful/FacilityAmenitiesCarousel';
import useCurrentPage from '../../../hooks/useCurrentPage';
import styles from './styles.scss';

// Utility function to detect mobile devices
const isMobile = () => /Mobi|Android/i.test(global.navigator.userAgent);

const propTypes = {
  title: PropTypes.string,
  amenities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  facility: PropTypes.shape({
    facilityAmenities: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
    amenities: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
  }),
  useFacilityAmenities: PropTypes.bool,
};

const defaultProps = {
  title: 'Facility Amenities',
  amenities: [],
  useFacilityAmenities: false,
  facility: undefined,
};

const FacilityAmenities = ({
  title,
  amenities,
  facility,
  useFacilityAmenities,
}) => {
  const [openAmenity, setOpenAmenity] = useState(null);

  const getAmenities = () => (useFacilityAmenities ? facility.facilityAmenities
    : facility.amenities);

  let defaultAmenities = [];

  if (facility && !amenities.length) {
    defaultAmenities = getAmenities().filter(amenity => amenity.enabled);
    defaultAmenities = defaultAmenities.map(amenity => ({
      name: amenity.name,
      description: '',
    }));
  }

  const { primaryColor, primaryFontFamily, secondaryFontFamily } = useCurrentPage();

  const displayAmenities = amenities.length ? amenities : defaultAmenities;

  const handleOpenAmenity = (name) => {
    setOpenAmenity(name);
  };

  const handleCloseAmenity = () => {
    setOpenAmenity(null);
  };

  // Use the isMobile utility to conditionally render components
  if (isMobile()) {
    return (
      <div className={styles.carousel}>
        <h3 className={styles.title} style={{ color: primaryColor }}>
          {title}
        </h3>
        <FacilityAmenitiesCarousel amenities={displayAmenities} />
      </div>
    );
  }

  return (
    <div>
      <Container className={styles.Container} style={{ maxWidth: '100%' }}>
        <Row>
          <h3
            className={styles.title}
            style={{ color: primaryColor, fontFamily: secondaryFontFamily }}
          >
            {title}
          </h3>
        </Row>
        <Row className="text-center">
          {displayAmenities.length > 0
            && displayAmenities.map(amenity => (
              <Col lg={4} md={4} sm={4} key={amenity.name}>
                <Amenity
                  {...amenity}
                  isOpen={openAmenity === amenity.name}
                  onOpen={() => handleOpenAmenity(amenity.name)}
                  onClose={handleCloseAmenity}
                  style={{ fontFamily: primaryFontFamily }}
                />
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );
};

FacilityAmenities.propTypes = propTypes;
FacilityAmenities.defaultProps = defaultProps;

FacilityAmenities.fragments = {
  facility: gql`
    fragment FacilityAmenities on Facility {
      amenities {
        name
        description
        enabled
      }
    }
  `,
};

export default FacilityAmenities;
